<template>
  <div class="wrap">
    <!-- 头部 -->
    <headTop :toggle="1"></headTop>
    <!-- 中间内容 -->
    <div class="aboutUsCenter">
      <div style="width: 100%">
        <!-- <div class="titlePosition" style="padding:1em 3em">
          <span>当前位置:</span>
          <span style="color:#2579BF">关于我们</span>
        </div> -->
        <div class="contentBox" style="background-color: #fff">
          <div class="contentTitle">
            <img src="@/assets/image/aboutUs/aboutUsBc.png" alt />
            <div class="line"></div>
            <div class="titleBcImg">
              <span>就医导图</span>
              <span class="eng">MEDICAL GUIDE MAP</span>
            </div>
            <div class="line"></div>
          </div>
          <div
            class="content target"
            style="margin-top: 54px; align-items: center"
          >
            <img
              style="width: 53em; height: 35em; display: flex"
              src="@/assets/image/aboutUs/hospitalizGuide05x.png"
              alt
            />
          </div>
        </div>
        <div class="contentBox">
          <div class="contentTitle">
            <img src="@/assets/image/aboutUs/aboutUsBc.png" alt />
            <div class="line"></div>
            <div class="titleBcImg">
              <span>关于我们</span>
              <span class="eng">ABOUT US</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="contentAbout">
            <h4>服务内容</h4>
            <span>{{ aboutUsInfo }}</span>
            <h4>我们的目标</h4>
            <span>{{ targetInfo }}</span>
            <h4>我们的特色</h4>
            <span>{{ characteristicInfo }}</span>

            <div class="video-wrapper">
            <video  controls style="margin-top:0.4rem; width:9rem;" poster="@/assets/image/aboutUs/VideoPoster.jpg">
              <source
                :src="`${$store.state.axiosUrl}/miniapp/img/abouUs/hjenVideo.mp4`"
                type="video/mp4"
              />
            </video>
           </div>
          </div>
        </div>
        <div class="contentBox1">
          <div class="contentTitle">
            <img src="@/assets/image/aboutUs/aboutUsBc.png" alt />
            <div class="line"></div>
            <div class="titleBcImg">
              <span>我们的服务</span>
              <span class="eng">OUR SERVICES</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="content target">
            <span>{{ servicesInfo }}</span>
          </div>
          <div class="imgList">
            <div
              class="imgListItem"
              v-for="(item, index) in imgList"
              :key="index"
            >
              <img :src="item.imgUrl" alt="" />
              <span class="title">{{ item.title }}</span>
              <div class="info">
                <span>{{ item.info }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="contentBox">
          <div class="contentTitle">
            <img src="@/assets/image/aboutUs/aboutUsBc.png" alt />
            <div class="line"></div>
            <div class="titleBcImg">
              <span>机构设置</span>
              <span class="eng">INSTITUTIONAL SETTING</span>
            </div>
            <div class="line"></div>
          </div>
          <div
            class="content target"
            style="margin-top: 54px; align-items: center"
          >
            <img
              style="width: 73em; height: 42em; display: flex"
              src="@/assets/image/aboutUs/4.png"
              alt
            />
          </div>
        </div>
      </div>

      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
export default {
  name: "aboutUs",
  components: {
    footCode,
    headTop,
  },

  data() {
    return {
      imgList: [
        {
          imgUrl: require("@/assets/image/aboutUs/1.png"),
          title: "环境治理",
          info: "废水、废气、固废等污染治理措施设计、施工及运营；河流及近岸海域环境污染修复和治理；污染土壤及地下水修复，矿山和农田修复等多元化环境修复；区域环境空气、河流、生态环境等整体解决方案及治理；污染物来源与特征分析。",
        },
        {
          imgUrl: require("@/assets/image/aboutUs/2.png"),
          title: "环境监测",
          info: "地表水（含地下水）和废水、环境空气和废气、土壤和水系沉积物、固体废物、海水、海洋沉积物、生物、生物体残留、噪声、振动、电磁辐射、电离辐射等生态环境全要素监测服务；全要素监测设备运维；生态环境状况、生物多样性调查。",
        },
        {
          imgUrl: require("@/assets/image/aboutUs/3.png"),
          title: "环境咨询",
          info: "环境影响评价、竣工环境保护验收、排污许可咨询服务、土壤环境调查评估、清洁生产审核、环境风险评估、环境应急预案、环境保护规划编制、环境政策研究、温室气体排放清单、碳资产管理、碳核查、环境权益抵（质）押融资、绿色基金与保险、环境诉讼。",
        },
      ],
      servicesInfo:
        "提供环境咨询、环境监测、环境治理等方面的服务，包括研发、设计、制造、销售、运维及第三方区域治理。",
      characteristicInfo:
        "首先，我们集成了中国环境科学研究院、生态环境部环境规划院、中国海洋大学、青岛理工大学、青岛市环境保护科学研究院等高校科研院所，拥有300余人专家团队，在环境污染防治、环境管理等领域积累了大量的先进技术与管理经验，可提供专业的一站式服务。其次，我们实施项目专员制，全程跟踪项目进展，通过开展“线上查询问诊、线下诊断治理”相结合的模式，为服务对象提供贴心优质的服务。第三，青岛环境医院是一家公立医院，具有公立、公益和普惠的属性，可为政府、企业、公众定期开展环境公益问诊。最后，青岛环境医院成员单位中有金融、法律等专业机构，可以协助服务对象提供工程建设投融资、法律咨询等方面的服务。",
      targetInfo:
        "建成一家组织架构完善、流程管理有序、产品服务丰富、保障措施有力的全国知名公立“环境医院”。",
      aboutUsInfo:
        "青岛环境医院是我省首批环境医院服务试点项目，我们整合了20余家成员单位的人才、技术、信息、金融、市场等优质资源，为政府、企业、公众提供环境政策咨询、环保问题诊断、系统解决方案、工程建设投融资、工程设计与施工、调试运营等全流程业务的环境服务，服务范围覆盖水污染防治、大气污染防治、固体废物处理处置、土壤及地下水修复、环境监测、环境咨询等领域。",
    };
  },
};
</script>
<style scoped lang="less">
// @import url('~@/assets/css/index.less');
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
  .video-wrapper{
    text-align: center;
  }
  .aboutUsCenter {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    // overflow: auto;
    // padding:0.2em 3em;
    .titlePosition {
      font-size: 0.15em;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      color: #666;
    }
    .contentTitle {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }

      .titleBcImg {
        height: 78px;
        // width: 113px;
        color: #333;
        font-weight: 600;
        background-size: cover;
        margin: 0 1em;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 0.18em;
        position: relative;
        .eng {
          color: #999999;
          font-size: 0.15em;
          position: absolute;
          white-space: nowrap;
          bottom: 0;
        }
      }
      .line {
        width: 250px;
        height: 1px;
        background-color: #999;
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      font-size: 17px;
      text-indent: 41px;
      color: #666;
    }
    .content.target {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 35em;
        width: 45em;
      }
    }
  }
}
.footer {
  width: 100%;
  // margin-top: 0.5em;
}
.contentBox {
  width: 100%;
  box-sizing: border-box;
  padding: 0.65em 3em 0.8em 3em;
}
.contentBox1 {
  background-color: #fff;
  padding: 0.65em 3em;
}
.imgList {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .imgListItem {
    background-color: #fff;
    border-radius: 20px;
    width: 30%;
    height: 465px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #666;
    font-size: 16px;
    border: 1px solid #e6e6e6;
    // text-align: center;
    img {
      height: 6em;
      width: 8.5em;
      margin-top: 40px;
    }
    .title {
      font-size: 22px;
      color: #333;
      margin-top: 30px;
    }
    .info {
      margin-top: 40px;
      text-indent: 36px;
    }
  }
}
.contentAbout {
  display: flex;
  flex-direction: column;
  font-size: 17px;
  color: #666;
  margin-top: 20px;
  h4 {
    color: #555;
    margin-top: 10px;
  }
  span {
    text-indent: 36px;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/index.vue